import { SignalIcon, SignalSlashIcon } from '@heroicons/react/24/solid';
import classNames from 'classnames';
import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useACLContext } from 'src/providers/ACLProvider/ACL.hook.ts';
import { useIntegrationsContext } from '../../../providers/IntegrationsProvider/Integrations.context.ts';
import { useLayoutContext } from '../../../providers/LayoutProvider/Layout.context.ts';
import { useModalsContext } from '../../../providers/ModalsProvider/Modals.context.ts';
import { useSubscriptionContext } from '../../../providers/SubscriptionProvider/Subscription.context.ts';

export function SidebarConnectionButton() {
  const { setConnectionModalIsOpen, setDisconnectionModalIsOpen } =
    useModalsContext();
  const { sidebarOpen } = useLayoutContext();
  const { whatsappIntegration } = useIntegrationsContext();
  const isConnected = whatsappIntegration.state === 'CONNECTED';
  const { isKnownNonClient } = useSubscriptionContext();
  const { setShowSubscribeIntegrationsModal } = useModalsContext();
  const { t } = useTranslation('sidebar/sidebarComponent');
  const { canUserAccessWhatsAppWebQr } = useACLContext();

  const sidebarMenu__Option__Text = classNames('Sidebar__Option__Text', {
    'Sidebar__Option__Text--success': isConnected,
    'Sidebar__Option__Text--warning': !isConnected,
  });

  const sidebarIconClasses = classNames('Sidebar__Option__Icon', {
    'Sidebar__Option__Icon--success': isConnected,
    'Sidebar__Option__Icon--warning': !isConnected,
  });

  const ButtonIcon = isConnected ? SignalIcon : SignalSlashIcon;
  const buttonText = isConnected
    ? t('page.connectionButton.connectedStatus')
    : t('page.connectionButton.disconnectedStatus');

  const onConnectionButtonClick = () => {
    // BUG-868: gate on the confirmed non-client signal, not `!isClient` — that
    // one is also true while the summary hasn't loaded (or its boot fetch
    // 401ed), and paywalled paying customers. Without data this fails open.
    if (isKnownNonClient) {
      setShowSubscribeIntegrationsModal(true);
      return;
    }
    if (isConnected) {
      setDisconnectionModalIsOpen(true);
      return;
    }

    if (canUserAccessWhatsAppWebQr()) setConnectionModalIsOpen(true);
  };

  return (
    <div className="relative group/connection">
      <Button
        className="Sidebar__Option"
        onClick={() => {
          onConnectionButtonClick();
        }}
        startIcon={<ButtonIcon className={sidebarIconClasses} />}
        color={'ghost'}
      >
        {sidebarOpen ? (
          <span className={sidebarMenu__Option__Text}>{buttonText}</span>
        ) : null}
      </Button>
      {!sidebarOpen && (
        <span className="pointer-events-none absolute left-full top-1/2 z-50 ml-2 -translate-y-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover/connection:opacity-100">
          {buttonText}
        </span>
      )}
    </div>
  );
}
